import { ReadStoreDto, ReadDefaultStoreDto, ReadMerchantDto, StoreTypeEnum } from '@goparrot/store-v2-sdk';
import { DateTime } from 'luxon';

export const getStoreTime = (store: ReadStoreDto | ReadDefaultStoreDto | ReadMerchantDto | undefined, currentTime: string): string => {
  if (store && store.contactInfo && store.type !== StoreTypeEnum.DEFAULT && store.type !== StoreTypeEnum.MERCHANT) {
    return DateTime.fromISO(currentTime, { zone: store.contactInfo.timeZone?.id }).toFormat('h:mm a');
  }
  return '';
};
